import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VApp,{attrs:{"id":"layout"}},[_vm._t("navbar"),_c(VMain,{staticClass:"content"},[_vm._t("content")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }